import { gql } from '@apollo/client';

export const CampaignAgentPhonesQuery = gql`
  query CampaignAgentPhones($campaignId: ID!) {
    campaign(id: $campaignId) {
      id
      agentPhones {
        locality
        messagingServiceId
        phone
        region
        status
      }
    }
  }
`;
